import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



export const EventRowItem = withConfig(theme => styled('div', { label: 'EventRowItem' })`

    align-items: center;

    display: flex;

    gap: 8px;

    min-width: 0;

    position: relative;

    width: 50%;

    &:last-of-type {

        &::before {

            align-items: center;

            bottom: 0;

            content: 'v';

            display: flex;

            flex: 0 0 16px;

            font-size: ${theme.star.eventRow.typography.fontSizePrimary};

            font-weight: ${theme.star.eventRow.typography.fontWeightSecondary};

            justify-content: center;

            line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

            margin: auto 8px;

            position: absolute;

            right: 100%;

            top: 0;

            width: 16px;

        }

    }

    &:first-of-type {

        flex-direction: row-reverse;

        &::before {

            content: none;

        }

    }

    @media ${theme.star.mediaQuery.desktop} {

        width: auto;

        &:first-of-type {

            flex-direction: row;

        }

        &:last-of-type {

            &::before {

                content: none;

            }

        }

    }

`);



const setEventRowItemLogo = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

  if (variant === DefaultComponentVariantType.TERTIARY) {

    return css`

        height: 24px;

        width: 24px;

    `

  }

  return css`

      height: 48px;

      width: 48px;

      @media ${theme.star.mediaQuery.desktop} {

          height: 32px;

          width: 32px;

      }

  `

}



export const EventRowItemLogo = withConfig(theme => styled('img', { label: 'EventRowItemLogo' })<{variant: DefaultComponentVariantType | null}>`

    display: block;

    ${({ variant }): SerializedStyles => setEventRowItemLogo(variant, theme)}

`);



interface EventRowParticipantNamePropsType {

    isHomeParticipant: boolean;

    variant: DefaultComponentVariantType | null

}



const setEventRowParticipantName = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

  if (variant === DefaultComponentVariantType.TERTIARY) {

    return css`

        font-size: ${theme.star.unified.eventRow.typography.fontSizePrimary};

        font-weight: ${theme.star.unified.eventRow.typography.fontWeightPrimary};

        line-height: ${theme.star.unified.eventRow.typography.lineHeightPrimary};

    `

  }

  return css`

      font-size: ${theme.star.eventRow.typography.fontSizePrimary};

      font-weight: ${theme.star.eventRow.typography.fontWeightPrimary};

      line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

  `

}



export const EventRowParticipantName = withConfig(theme => styled('div', { label: 'EventRowParticipantName' })<EventRowParticipantNamePropsType>`

    color: ${theme.star.eventRow.txtColor};

    ${({ variant }): SerializedStyles => setEventRowParticipantName(variant, theme)}

    overflow: hidden;

    position: relative;

    text-align: ${({ isHomeParticipant }): string => isHomeParticipant ? 'right' : 'left'};

    text-overflow: ellipsis;

    white-space: nowrap;

`);

